// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ce73","delete":"styles_delete__1O7i_","update":"styles_update__3Gh3-","add":"styles_add__3icwi"};